{
  "splash": {
    "poweredBy": "Propulsé par :",
    "title": "Développé avec le support de la MAPAQ"
  },
  "guidelines": {
    "secondParagraph": "<strong>Veille à remettre les équipements empruntés</strong> dans l'état dans lequel ils t'ont été prêtés. Si un problème survient avec un équipement, contacte-nous par la messagerie ou par courriel à : lepotluckhg@hautegaspesie.com",
    "thirdParagraph": "<strong>Respecte les dates de retour des prêts.</strong>",
    "fourthParagraph": "<strong>Sois généreux</strong> en répondant proactivement aux besoins des membres.",
    "fifthParagraph": "N'utilise pas Le PotLuck Haute-Gaspésie pour louer des ressources.",
    "startingKit": "Je veux recevoir la <startingKitLink>Trousse de départ</startingKitLink> par la poste pour recruter les autres membres (optionnel)"
  },
  "my-information": {
    "firstNameFieldLabel": "Nom de l'organisation",
    "firstNameFieldPlaceholder": "Nom de l'organisation",
    "my-neighborhood-club": "Mon club de région"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nom de l'organisation",
    "firstNameFieldPlaceholder": "Nom de l'organisation",
    "bioFieldLabel": "À propos de l'organisation",
    "bioFieldPlaceholder": "À propos de l'organisation"
  },
  "contact-information": {
    "mapStatsPrompt": "Ajuste le rayon de recherche pour visualiser le nombre de membres et d'offres disponibles."
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "firstLine": "Le montant que les autres membres économisent en empruntant tes ressources s’affichera ici.",
        "secondLine": "Partage tes ressources et vois combien d'argent tu permets aux membres d'économiser !"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "firstLine": "Le montant que les autres membres économisent en empruntant tes ressources s’affichera ici.",
          "secondLine": "Partage tes ressources et vois combien d'argent tu permets aux membres d'économiser !"
        }
      },
      "give": {
        "borrowing": {
          "firstLine": "La valeur des ressources que tu reçois s’affichera ici.",
          "primaryButtonText": "Voir les ressources à donner",
          "secondLine": "Récupère des ressources et suis la valeur de tes dons reçus !"
        },
        "lending": {
          "firstLine": "La valeur des ressources que tu donnes s’affichera ici.",
          "secondLine": "Donne des ressources et suis la valeur de tes dons !"
        }
      }
    },
    "howItWorks": {
      "body": "Nous utilisons un outil d'intelligence artificielle pour déterminer le prix de chaque ressource empruntée",
      "bodyByTransaction": {
        "lend": "Nous utilisons un outil d'intelligence artificielle pour déterminer le prix de chaque ressource empruntée",
        "sell": "Nous utilisons un outil d'intelligence artificielle pour estimer la valeur de chaque ressource vendue",
        "give": "Nous utilisons un outil d'intelligence artificielle pour estimer la valeur de chaque ressource donnée"
      }
    },
    "subtext": {
      "borrowing": "en empruntant des ressources",
      "lending": "en prêtant mes ressources"
    },
    "subtextByTransaction": {
      "lend": {
        "borrowing": "en empruntant des ressources",
        "lending": "en prêtant mes ressources"
      },
      "sell": {
        "borrowing": "en achetant des ressources",
        "lending": "en vendant mes ressources"
      },
      "give": {
        "borrowing": "en recevant des ressources",
        "lending": "en donnant mes ressources"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nom de l'organisation",
    "firstNameFieldPlaceholder": "Nom de l'organisation",
    "title": "Ton profil"
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenue sur Le PotLuck Haute-Gaspésie",
    "title": "Bienvenue sur Le PotLuck Haute-Gaspésie",
    "community": {
      "headerText": "L'application pour <strong>prêter, vendre et donner des ressources</strong> entre acteurs du territoire de la Haute-Gaspésie",
      "footerText": "Ne te <strong>limite</strong> pas aux ressources de ton organisation."
    },
    "accessMore": {
      "headerText": "Sur Le PotLuck Haute-Gaspésie, accède à une <strong>abondance de ressources</strong>.",
      "footerText": "Équipements, matières, véhicules, etc. : ici, tu peux <strong>emprunter, acheter ou recevoir</strong> ce dont ton organisation a besoin."
    },
    "offerMore": {
      "headerText": "<strong>Prêter, vendre ou donner</strong>, c'est <strong>aider</strong> d'autres acteurs du territoire tout en <strong>optimisant tes ressources</strong>.",
      "footerText": "Fais <strong>profiter</strong> les autres organisations de tes ressources sous-utilisées."
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenue dans la communauté",
    "title": "Présentation de la communauté",
    "congratulation": {
      "congratulation": "Félicitations !",
      "text1": "Tu es officiellement membre {{name}}.",
      "text2": "",
      "text3": "<strong>Grâce à {{name}}, ton abonnement est gratuit.</strong> 🎉\n\n",
      "text4": "Profites-en pour partager et échanger de façon illimitée avec la communauté."
    },
    "newFlow": {
      "oneFreeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "quickInterest": {
    "headerTitle": "Centres d'intérêt",
    "title": "Quels sont tes centres d'intérêt ?",
    "subtitle": "Personnalise tes recommandations et sois notifié des nouvelles offres.",
    "instruction": "Sélectionne un ou plusieurs intérêts :",
    "nothingSelectedError": {
      "buttonText": "Retour",
      "text": "Tu dois sélectionner au minimum un centre d'intérêt pour continuer.",
      "title": "Sélectionne 1+ centre(s) d'intérêt"
    },
    "button": {
      "confirm": "Confirmer",
      "skip": "Peut-être plus tard"
    }
  },
  "quick-new-thanks": {
    "bodyText": "Tu peux à tout moment aller modifier tes offres dans ton centre de partages.\n\nTon profil est complet, tu es prêt·e à commencer à <strong>échanger!</strong>",
    "didYouKnowBody": "Les annonces avec de vraies photos augmentent tes chances d'être contacté. Tu peux aller voir tes annonces pour les bonifier !"
  },
  "contact-us": {
    "faqLink": "https://www.hautegaspesie.com/developpement/documentation/partage-club#foire-aux-questions"
  },
  "privacy": {
    "link1": "https://www.hautegaspesie.com/developpement/documentation/partage-club#conditions-generales-dutilisation",
    "link2": "https://www.hautegaspesie.com/developpement/documentation/partage-club#politique-de-confidentialite"
  },
  "loanDatesPicker": {
    "informationTextAsBorrower": "Propose des dates au prêteur pour effectuer la réservation et suivre l’équipement jusqu’à son retour."
  },
  "help": {
    "title": "Comment échanger des ressources ?",
    "roleBorrow": "Je cherche une ressource",
    "roleLend": "Je propose une ressource",
    "compensation": {
      "title": "Dédommagement sur les ressources",
      "text": "Tu es dédommagé sur les ressources prêtées et empruntées",
      "subscribeText": "Avec l'abonnement, Partage Club te dédommage jusqu'à 300 $ sur les ressources prêtées et empruntées."
    },
    "borrower": {
      "steps": {
        "catalog": {
          "title": "Parcours les ressources",
          "text": "Cherche une ressource à emprunter, acheter ou recevoir en don dans le catalogue, ou crée un besoin visible par les autres membres."
        },
        "meeting": {
          "title": "Conviens des modalités",
          "text": "Contacte le membre pour préciser s'il s'agit d'un prêt, d'une vente ou d'un don, puis propose et confirme la date de l'échange."
        },
        "pickup": {
          "title": "Récupère la ressource",
          "text": "Rencontre l'autre membre à son domicile ou dans un lieu public sécuritaire."
        },
        "return": {
          "title": "Finalise l'échange",
          "text": "S'il s'agit d'un prêt, retourne la ressource en bon état. Pour une vente ou un don, confirme simplement que l'échange est terminé."
        }
      }
    },
    "lender": {
      "steps": {
        "photo": {
          "title": "Prends une ressource en photo",
          "text": "Prends quelques clichés qui mettent en valeur ta ressource"
        },
        "publish": {
          "text": "Ajoute les détails de ta ressource, puis choisis si tu souhaites la prêter, la vendre ou la donner. Pour publier rapidement un prêt, tu peux aussi choisir parmi les ressources suggérées.",
          "suggestedLink": "Choisir parmi les ressources suggérées"
        },
        "share": {
          "title": "Remets la ressource",
          "text": "Rencontre l'autre membre à ton organisation ou dans un lieu convenu, puis remets-lui la ressource selon les modalités du prêt, de la vente ou du don."
        },
        "return": {
          "title": "Finalise l'échange",
          "text": "Pour un prêt, récupère ta ressource à la date convenue. Pour une vente ou un don, confirme simplement que l'échange est terminé, puis partage ton expérience."
        }
      }
    },
    "guestCta": {
      "text": "Rejoins les autres membres et découvre tout ce que tu peux emprunter près de chez toi."
    }
  },
  "landing-page": {
    "multipleOfferCard": {
      "title": "Tu as sûrement ces ressources!"
    },
    "upcomingActivity": {
      "allWindow": "Tous tes échanges actifs",
      "openDetails": "Ouvre le détail de l’échange"
    },
    "stepsToComplete": {
      "addListings": "Ajoute ({{count}}/5) ressources à prêter"
    },
    "immature": {
      "defricheur": {
        "text": "Il y a peu d'objets dans ta région. <strong>Abonnement gratuit aux 5 premier.ère.s</strong> qui publieront un objet."
      },
      "referral": {
        "button": "Invite les autres membres"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "Nous te préviendrons si des membres ont besoin d’aide"
      }
    }
  },
  "all-listings": {
    "hasAcceptedLoan": "a prêté la ressource",
    "hasAcceptedLoanAgo": "a comblé le besoin il y a {{ago}}",
    "addAddressPrompt": {
      "button": "Ajouter une région"
    },
    "empty": {
      "invite": {
        "secondLine": "Invite des membres ou publie une offre dans ta région.",
        "primaryButtonText": "Invite les autres membres"
      }
    },
    "filter": {
      "neighborhoodClubCheckbox": "<strong>Club de proximité</strong>{{suffix}}",
      "neighborhoodClub": "Club de proximité"
    },
    "inviteOthersPrompt": {
      "title": "Aide-nous à faire grandir la communauté dans ta région!",
      "description": "Ta région semble immature, c'est-à-dire qu'il y a peu de membres dans les environs mais tu peux changer la donne !",
      "ctaButton": "Invite les autres membres"
    },
    "needLogin": {
      "secondLine": "Connecte-toi pour voir les objets disponibles dans ta région."
    },
    "bonificationPrompt": {
      "title_one": "Une annonce à bonifier!",
      "title": "{{numListings}} annonces à bonifier!",
      "text_one": "Tu as <strong>une annonce</strong> avec une photo générique ou aucune description. Les annonces avec une photo ont plus de chances d'être contactées!",
      "text": "Tu as <strong>{{numListings}} annonces</strong> avec une photo générique ou aucune description. Les annonces avec une photo ont plus de chances d'être contactées!",
      "button_one": "Compléter la fiche de l'annonce"
    },
    "numResults": {
      "all_zero": "{{count}} ressources",
      "all_one": "{{count}} ressource",
      "all": "{{count}} ressources",
      "lend_zero": "{{count}} offres de prêt",
      "lend_one": "{{count}} offre de prêt",
      "lend": "{{count}} offres de prêt",
      "sell_zero": "{{count}} offres de vente",
      "sell_one": "{{count}} offre de vente",
      "sell": "{{count}} offres de vente",
      "give_zero": "{{count}} offres de don",
      "give_one": "{{count}} offre de don",
      "give": "{{count}} offres de don"
    },
    "banner": {
      "xmas": {
        "text": "Les Fêtes arrivent ! Aide les autres membres à trouver ces objets souvent demandés."
      }
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Inviter les autres membres",
        "title": "Invite les autres membres !"
      },
      "third": {
        "title": "Demande aux autres membres"
      }
    }
  },
  "group-members": {
    "filter": {
      "neighborhoodClub": "Club de proximité"
    }
  },
  "introModal": {
    "offreDefricheur": "Il y a peu d'objets dans ta région. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
    "notInsurable": {
      "community": "<strong>C’est l’occasion parfaite pour faire connaissance avec les autres membres</strong>, et faire un pas vers un monde durable."
    },
    "welcome": {
      "withWho": {
        "enterprise": "tes collègues et les autres membres",
        "municipal": "les autres membres",
        "municipal_closed": "les autres membres",
        "realestate": "les autres membres"
      }
    }
  },
  "notifications": {
    "welcome": "Bienvenue sur Le Potluck!",
    "welcomeMessage": "Merci de nous faire confiance!",
    "loanReciprocity": {
      "message": "Publie les objets que tu utilises peu et fais-en profiter les autres membres."
    }
  },
  "my-clubs": {
    "addProClubButton": "Modifier mes secteurs d'activités",
    "createClubButton": "Ajouter une adresse",
    "help": {
      "neighbourhoods": {
        "title": "Mes adresses",
        "paragraph1": "Ajoute des adresses que tu fréquentes souvent pour accéder à plus d’offres et élargir tes offres à plus de membres.",
        "paragraph2": "Un entrepôt, un commerce, etc."
      },
      "pro": {
        "title": "Clubs sectoriels",
        "paragraph1": "Un club partenaire est géré par une organisation comme ta ville, employeur, association ou université. Ajoute un tel club si tu as reçu un code d'invitation."
      }
    },
    "neighbourhoodClubName": "Adresse principale",
    "proTitle": "Clubs sectoriels",
    "neighbourhoodTitle": "Mes adresses"
  },
  "my-neighbourhood": {
    "addAddressHelp": "Avoir plus d’une adresse te permet d’accéder à plus d’offres et d’élargir tes offres à plus de membres",
    "createClubButton": "Ajouter cette adresse",
    "deleteConfirmation": "Supprimer cette adresse ?",
    "neighborhoodClub": "Club de proximité",
    "radiusDescription": "Ton rayon te permet de partager tes annonces dans un périmètre limité de ta région. Les membres habitant hors de cette zone ne pourront pas voir tes annonces.",
    "titleNew": "Ajouter une adresse"
  },
  "travel-distance": {
    "text": "La distance de recherche s'applique uniquement aux annonces de ton Club de région."
  },
  "my-plan": {
    "freeSubText": {
      "defricheur": "Il y a peu d'objets dans ta région. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet."
    },
    "businessPlan": {
      "title": {
        "enterprise": ""
      }
    },
    "extraGroups": "Secteurs d'activités sélectionnés",
    "design": {
      "freeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldLabel": "Nom de la ressource",
      "assistant": {
        "knowMore": {
          "text1": "Notre nouvel assistant intelligent <strong>relie</strong> tes besoins à des <strong>offres pertinentes</strong> et <strong>contacte automatiquement</strong> les membres en se basant sur ta <strong>description</strong> et la <strong>distance souhaitée</strong>.",
          "text2": "Pour que l'assistant puisse t'aider au mieux, donne un <strong>maximum de détails</strong> relatifs à la ressource dans la description."
        }
      }
    },
    "chooseAutomaticMessage": {
      "defaultAutomaticMessage": {
        "greeting": "Salut {{firstName}}! Je cherche la ressource suivante, et le système de recommandations pense que tu pourrais potentiellement m'aider :\n\n"
      }
    },
    "hauteGaspesie": {
      "headerTitle": "Publier une offre",
      "resourceType": {
        "equipment": "Objet, équipement...",
        "perishable": "Matière périssable"
      },
      "addPicture": "Ajouter des photos",
      "pictureHint": "Jusqu’à {{max}} photos. Des images claires et bien éclairées rendent l’offre plus attrayante.",
      "resourceName": "Nom de la ressource",
      "resourceNamePlaceholder": "Ex: Plumeuse rotative",
      "descriptionPlaceholder": "Max 280 caractères",
      "transaction": {
        "sell": "💵 Vendre",
        "lend": "🤝 Prêter",
        "give": "🎁 Donner"
      },
      "price": "Prix",
      "pricePlaceholder": "50 $/kg",
      "urgent": {
        "title": "Urgent?",
        "description": "Une alerte sera instantanément envoyée aux autres membres à la publication et ton annonce sera mise en évidence"
      },
      "availability": {
        "title": "Disponibilité",
        "startLabel": "Début (optionnel)",
        "endLabel": "Fin (optionnelles)",
        "placeholder": "Confirmer vos dates",
        "startPickerTitle": "Début de disponibilité",
        "endPickerTitle": "Fin de disponibilité",
        "confirm": "Confirmer"
      }
    },
    "locationSection": {
      "addressFieldTitle": "Club de proximité",
      "clubsTitle": "Clubs sectoriels"
    },
    "prompt": {
      "offer": {
        "title": "Offres",
        "one": "Ressource spécifique",
        "perishable": "Ressource périssable",
        "donation": "Offrir une ressource",
        "bulk": "Créer plusieurs offres à partir de photos",
        "many": "Ressources suggérées"
      },
      "request": {
        "title": "Besoins",
        "one": "Emprunter une ressource",
        "donation": "Demander un don",
        "service": "Demander un service"
      }
    },
    "urgentSection": {
      "urgentRequiresExpirable": "L'option Urgent? est réservée aux matières périssables."
    }
  },
  "profile-overview": {
    "streakHood": "Série de région",
    "inviteNeighboursButtonLabel": "Inviter des membres"
  },
  "ambassador": {
    "advantages": {
      "advantage1": {
        "body": "Des personnes de ta région, qui, comme toi, veulent créer une résilience locale"
      }
    },
    "mission": {
      "mission2": "Inspirer et mobiliser sa communauté : Donner envie de partager, montrer l'exemple et créer un effet d'entraînement dans sa région"
    }
  },
  "streak": {
    "headerTitle": "Série de région",
    "title": "Série de région",
    "objectiveDetails": "L’objectif du mois est déterminé en fonction du nombre de membres partageur·euse·s autour de toi et de la maturité de ta région.",
    "neighbourhoodFirstShare": "Dans ta région, <strong>{{percent}}% des autres membres</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>.",
    "contributions": {
      "add_avatar": {
        "description": "Une photo de profil rassure les autres membres et te rend reconnaissable dans la région."
      },
      "dismiss_request": {
        "title": "Essaye d'aider les autres membres"
      },
      "publish_offer": {
        "description": "Publie un objet spécifique, ou choisis parmi les objets suggérés, déjà proposés par les autres membres !"
      },
      "send_message": {
        "description": "Brise la glace! Écris à un membre pour proposer ton aide ou en savoir plus sur une annonce."
      }
    },
    "seriesDetails": "Pour garder la flamme du partage active, toi et les autres membres devez atteindre l’objectif de partages indiqué pour le mois.",
    "tips": {
      "helpNeighbours": {
        "title": "Essaye d'aider les autres membres"
      }
    }
  },
  "one-listing": {
    "hasAcceptedLoan": "a prêté la ressource",
    "hasAcceptedLoanAgo": "a comblé le besoin il y a {{ago}}",
    "confirmDonationDoneModal": {
      "text": {
        "borrower": "En confirmant que le don a été ramassé, tu indiques que {{name}} t’a bien donné cette ressource.",
        "lender": "En confirmant, tu reconnais avoir donné à {{name}} la ressource en question."
      }
    },
    "availabilitySection": {
      "reservations": {
        "title": "Dates",
        "text": "Choisir une date limite de ramassage"
      },
      "donation": {
        "reservations": {
          "text": "Choisir une date limite de ramassage"
        }
      },
      "loan": {
        "reservations": {
          "title": "Réservation",
          "optionalLabel": "optionnelle",
          "text": "Rendre indisponible pour mon usage"
        }
      },
      "quantity": {
        "fieldPlaceholder": "1kg/lb/unité"
      }
    }
  },
  "one-loan": {
    "saleHistory": {
      "accepted_when": "Vente acceptée le {{date}}",
      "end_when": "Vente prévue · {{date}}",
      "late_x_days": "Vente en retard · {{numDays}} jours",
      "late_yesterday": "Vente en retard · 1 jour",
      "offered_when": "Proposition de vente envoyée le {{date}}",
      "returned_when": "Vente confirmée par {{who}} · {{date}}",
      "started_when": "Vente prévue le {{date}}"
    },
    "transactionDate": "Date de la vente",
    "title": {
      "donation": "Détail du don"
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Cher·ère organisation,",
      "text": {
        "lender": {
          "before": "Gère la disponibilité de tes ressources : bloque-les pour tes projets et mutualise-les quand tu n’en as pas besoin*.",
          "after": "Gère la disponibilité de tes ressources : bloque-les pour tes projets et mutualise-les quand tu n’en as pas besoin*."
        },
        "borrower": "Gère la disponibilité de tes ressources : bloque-les pour tes projets et mutualise-les quand tu n’en as pas besoin*."
      },
      "subtext": {
        "lender": {
          "before": "*(Prévois le transport et la manutention si besoin)",
          "after": "*(Prévois le transport et la manutention si besoin)"
        },
        "borrower": "*(Prévois le transport et la manutention si besoin)"
      }
    },
    "conflictsInformationText": "Certaines ressources sont <strong>déjà prêtés</strong> pour ces dates. Vous pouvez continuer la réservation, mais contactez l'emprunteur ensuite pour résoudre ce(s) conflit(s).",
    "informationText": "Réserve tes ressources pour les rendre indisponibles à l'emprunt."
  },
  "recommendations": {
    "urgent-needs": {
      "title": "Ils ont besoin d'aide!"
    },
    "recent-loans": {
      "title": "Échanges récents",
      "badge": {
        "lend": "Prêt",
        "sell": "Vente",
        "give": "Don"
      },
      "concluded": {
        "lend": "ont conclu un prêt pour",
        "sell": "ont conclu une vente pour",
        "give": "ont conclu un don pour"
      }
    }
  },
  "interests": {
    "chooseTag": {
      "title": {
        "lender": "Choisis les catégories de ressources que tu possèdes et que tu pourrais partager"
      },
      "subtitle": {
        "lender": "Ça nous aidera à te proposer des idées de ressources à partager."
      }
    },
    "chooseListing": {
      "aggregateTitle": {
        "borrower": "Selon les intérêts choisis, voici des ressources qui pourraient t’intéresser.",
        "lender": "Selon les intérêts choisis, nous avons trouvé des ressources souvent demandées que tu pourrais partager.",
        "both": "Selon les intérêts choisis, voici des ressources qui pourraient t’intéresser."
      }
    }
  },
  "quick-new-confirm": {
    "buttonText": "Publier ({{num}})",
    "secondaryButtonText": "Retour",
    "headerText": "En <strong>appuyant sur Publier</strong>, les ressources sélectionnées seront publiées <strong>sur ton profil</strong> et d'autres personnes <strong>pourront te les demander</strong>",
    "headerTitle": "Confirmation",
    "almostThere": "On y est presque !"
  },
  "one-channel": {
    "addToCalendar": {
      "modal": {
        "always": "Oui, pour tous les échanges"
      }
    },
    "howItWorks": {
      "borrow": {
        "step1": "<bold>Écris un mot</bold> pour te présenter et <bold>exprimer ton intérêt</bold> pour la ressource",
        "step2": "<bold>Conviens des modalités</bold> avec l'autre membre, puis <bold>planifie la date et le lieu de l'échange</bold>",
        "step3": "<bold>Récupère la ressource</bold> auprès de l'autre membre ou dans un lieu convenu",
        "step4": "<bold>Finalise l'échange</bold> selon les modalités convenues et partage ton expérience"
      },
      "lend": {
        "step1": "<bold>Réponds au message</bold> pour faire connaissance et <bold>discuter des modalités de l'échange</bold>",
        "step2": "<bold>Conviens des modalités</bold> avec l'autre membre, puis <bold>planifie la date et le lieu de l'échange</bold>",
        "step3": "<bold>Remets la ressource</bold> à l'autre membre selon les modalités convenues",
        "step4": "<bold>Finalise l'échange</bold> et partage ton expérience"
      }
    },
    "loanMessage": {
      "contentAsBorrower": "Le prêteur doit confirmer pour que la ressource soit réservée.",
      "contentAsLender": "L’emprunteur doit confirmer pour que la ressource soit réservée.",
      "contentPending": "La proposition de dates doit être acceptée afin que la ressource soit réservée."
    },
    "bonification": {
      "lenderNudge": {
        "title": {
          "lend": "Quelqu'un veut emprunter ta ressource 👋",
          "sell": "Quelqu'un veut acheter ta ressource 👋",
          "give": "Quelqu'un veut recevoir ta ressource 👋"
        },
        "text": "Pour que l'échange se passe encore mieux, ajoute une vraie photo et une courte description. Ça inspire confiance et rend ta ressource plus attrayante!",
        "cta": "Compléter la fiche de la ressource"
      }
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "title": "Publier tes premières ressources",
        "text": "En proposant tes ressources, tu aides les autres organisations du territoire à trouver ce dont elles ont besoin."
      }
    },
    "publishOffers": {
      "step1": {
        "title": "Prendre soin des ressources",
        "text": "Ici, la <strong>confiance</strong> règne. Tous les membres s'engagent à respecter les règles d'or.\n\nEn cas de problème, <strong>l'équipe du PotLuck Haute-Gaspésie</strong> est à ton service. (1/5)"
      },
      "step2": {
        "title": "Proposer tes ressources",
        "text": "En publiant les ressources que tu peux prêter, vendre ou donner, tu aides les autres organisations du territoire à répondre à leurs besoins.\n\nAppuie sur l'icône pour continuer. (2/5)"
      },
      "step2AltCorp": {
        "title": "Proposer tes ressources",
        "text": "En publiant les ressources que tu peux prêter, vendre ou donner, tu aides les autres organisations du territoire à répondre à leurs besoins.\n\nAppuie sur l'icône pour continuer. (2/5)"
      },
      "step3": {
        "title": "2 façons de publier tes ressources",
        "text": "Publie une ressource à la fois ou plusieurs ressources en même temps. <strong>Sélectionne l'offre multiple</strong> pour continuer. (3/5)"
      },
      "step4": {
        "title": "Ta ressource est publiée",
        "text": "Tu peux modifier tes annonces à tout moment. (4/5)"
      },
      "step4AltPlural": {
        "title": "Tes ressources sont publiées",
        "text": "Tu peux modifier tes annonces à tout moment. (4/5)"
      },
      "step5": {
        "title": "Publier une ressource à la fois",
        "text": "Pour une offre individuelle, prends une photo de ta ressource, puis choisis si tu souhaites la prêter, la vendre ou la donner. (5/5)"
      },
      "stepFinal": {
        "title": "Bravo !",
        "text": "Tu maîtrises maintenant la publication de ressources.\n\nGrâce au prêt, à la vente et au don, ton organisation contribue à optimiser les ressources du territoire."
      }
    },
    "chatIntro": {
      "step2": {
        "title": "Organiser l'échange",
        "text": "Clique ici pour proposer une date de ramassage. Selon l'offre, tu pourras emprunter, acheter ou recevoir la ressource en don. L'autre membre pourra ensuite accepter ou refuser."
      },
      "step2AltRequest": {
        "title": "Organiser l'échange",
        "text": "Clique ici pour proposer une date afin de répondre au besoin. Selon l'annonce, tu pourras prêter ou donner la ressource. L'autre membre pourra ensuite accepter ou refuser."
      }
    },
    "firstMessageSent": {
      "step1": {
        "title": "Proposer une date",
        "text": "Une fois les modalités du prêt, de la vente ou du don convenues, indique la date de l'échange pour le finaliser."
      }
    },
    "homeExplore": {
      "step1": {
        "title": "Cherche une ressource",
        "text": "Utilise la barre de recherche et les filtres pour trouver une ressource à emprunter, acheter ou recevoir en don."
      },
      "step2": {
        "title": "Publie une offre ou un besoin",
        "text": "Utilise ce bouton pour proposer une ressource à prêter, vendre ou donner. Tu peux aussi demander l'aide de la communauté en publiant un besoin."
      },
      "step3": {
        "text": "Clique ici pour découvrir comment fonctionnent le prêt, la vente et le don."
      }
    },
    "contactMember": {
      "step1": {
        "title": "On y est presque ! Contacte le membre",
        "text": "Consulte les détails de l'annonce. Si tu souhaites échanger à ce sujet, clique ici pour contacter le membre qui l'a publiée."
      }
    }
  },
  "tutorialModal": {
    "publishOffers": {
      "text": "<strong>Comment prêter, vendre ou donner tes ressources</strong>",
      "title": "Découvrir les échanges de ressources"
    }
  },
  "bonificationPrompt": {
    "title_one": "Une offre à bonifier!",
    "title": "{{numListings}} offres à bonifier!",
    "text_one": "Tu as <strong>une offre</strong> avec une photo générique ou aucune description. Les offres avec une photo ont plus de chances d'être empruntées!",
    "text": "Tu as <strong>{{numListings}} offres</strong> avec une photo générique ou aucune description. Les offres avec une photo ont plus de chances d'être empruntées!",
    "button_one": "Compléter la fiche de l'offre",
    "button": "Voir mes annonces",
    "dismiss": "Fermer"
  },
  "free-sub": {
    "inviteButtonText": "Inviter les autres membres",
    "spreadTheLoveText": "Parle-en aux autres membres pour qu’eux.elles aussi puissent profiter de l’offre spéciale !"
  },
  "invite": {
    "title": "Invite les autres membres ou tes proches !"
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Économisé par les autres membres grâce à toi"
        }
      }
    }
  },
  "payment": {
    "modal": {
      "firstParagraph": "Merci de ta confiance. Grâce à ton abonnement, tu peux maintenant emprunter et prêter des objets aux autres membres sans limite."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "Un objet emprunté, une belle rencontre…\nPartage ton histoire avec les autres membres."
      }
    },
    "storyComposer": {
      "neighbour": "un membre"
    }
  }
}
